import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { analyticsTrack } from '../../../analyticsUtils';
import { putRequest } from '../../../requestUtils';
import '../ProjectDetails.scss';
import ProTip from '../ProTip';
var TEXT_SUGGESTION = "We are a [add stage(s) of development here] - stage [add industry here] company focusing on [add company's primary technologies and/or therapeutic units of focus here]. We are looking for a [add role name here] consultant with proven expertise in [add primary therapeutic areas, product technologies, diseases, and/or other skill here] to accomplish [add key deliverables or milestones here]. Our ideal candidate will have [add required expertise and/or years of experience here]. [Add nice to have attributes or experience here] is preferred.";
var formStep = 'scope';
var ProjectScope = /*#__PURE__*/function (_Component) {
  function ProjectScope(props) {
    var _this;
    _classCallCheck(this, ProjectScope);
    _this = _callSuper(this, ProjectScope, [props]);
    _this.state = {
      showModal: false,
      errors: null,
      projectScope: props.projectScope
    };
    _this.handleShowModal = _this.handleShowModal.bind(_this);
    _this.handleHideModal = _this.handleHideModal.bind(_this);
    _this.handleBack = _this.handleBack.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleTextSuggestions = _this.handleTextSuggestions.bind(_this);
    _this.setScope = _this.setScope.bind(_this);
    return _this;
  }
  _inherits(ProjectScope, _Component);
  return _createClass(ProjectScope, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var _this$props = this.props,
        projectResourceId = _this$props.projectResourceId,
        getProjectDetails = _this$props.getProjectDetails;
      if (!projectResourceId) return;
      getProjectDetails(formStep).then(function (response) {
        _this2.setState({
          projectScope: response.data.description
        });
      });
    }
  }, {
    key: "setScope",
    value: function setScope(e) {
      this.setState({
        projectScope: e.target.value
      });
    }
  }, {
    key: "handleShowModal",
    value: function handleShowModal() {
      this.setState({
        showModal: true
      });
    }
  }, {
    key: "handleHideModal",
    value: function handleHideModal() {
      this.setState({
        showModal: false
      });
    }
  }, {
    key: "handleBack",
    value: function handleBack() {
      if (this.props.formType === 'page') {
        this.props.back();
      } else {
        this.handleHideModal();
      }
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var _this3 = this;
      var _this$props2 = this.props,
        csrfToken = _this$props2.csrfToken,
        projectResourceId = _this$props2.projectResourceId,
        afterSubmit = _this$props2.afterSubmit;
      var projectScope = this.state.projectScope;
      putRequest("/projects/".concat(projectResourceId), {
        project: {
          description: projectScope
        }
      }, csrfToken).then(function () {
        afterSubmit();
      })["catch"](function (error) {
        _this3.setState({
          errors: error.name
        });
      });
    }
  }, {
    key: "handleTextSuggestions",
    value: function handleTextSuggestions() {
      var projectScope = this.state.projectScope;
      analyticsTrack('Inserted text suggestion (project scope)', {
        location: 'Project creation'
      });
      var prevText = '';
      if (projectScope) {
        prevText = projectScope;
      }
      var textSuggestion = prevText + TEXT_SUGGESTION;
      this.setState({
        projectScope: textSuggestion
      });
    }
  }, {
    key: "renderModal",
    value: function renderModal() {
      return /*#__PURE__*/React.createElement(Modal, {
        show: this.state.showModal,
        onHide: this.handleHideModal,
        dialogClassName: "project-scope-modal"
      }, /*#__PURE__*/React.createElement(Modal.Header, {
        closeButton: true
      }), /*#__PURE__*/React.createElement(Modal.Body, {
        className: "project-scope-modal-body"
      }, this.renderContent()));
    }
  }, {
    key: "renderButtons",
    value: function renderButtons() {
      var _this$props3 = this.props,
        backButtonText = _this$props3.backButtonText,
        submitButtonText = _this$props3.submitButtonText;
      var disabledState = this.state.projectScope && this.state.projectScope.length > 3 ? '' : 'disabled';
      return /*#__PURE__*/React.createElement("div", {
        className: "buttons-container g-row mt-4"
      }, /*#__PURE__*/React.createElement("div", {
        className: "g-column g-flex-6"
      }), /*#__PURE__*/React.createElement("div", {
        className: "g-column g-flex-3"
      }, /*#__PURE__*/React.createElement("button", {
        className: "btn btn-secondary button-back",
        onClick: this.handleBack
      }, backButtonText)), /*#__PURE__*/React.createElement("div", {
        className: "g-column g-flex-3"
      }, /*#__PURE__*/React.createElement("button", {
        className: "btn btn-primary button-submit ".concat(disabledState),
        onClick: this.handleSubmit,
        disabled: disabledState
      }, submitButtonText)));
    }
  }, {
    key: "renderErrors",
    value: function renderErrors() {
      var errors = this.state.errors;
      return errors && /*#__PURE__*/React.createElement("div", {
        id: "error_explanation"
      }, /*#__PURE__*/React.createElement("h3", null, "Errors prohibited this project from being saved:"), /*#__PURE__*/React.createElement("ul", null, errors.map(function (e) {
        return /*#__PURE__*/React.createElement("li", null, e);
      })));
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      return /*#__PURE__*/React.createElement("div", {
        className: "style-guide project-scope-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "g-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "g-column g-flex-1"
      }), /*#__PURE__*/React.createElement("div", {
        className: "g-column g-flex-6 scope-entry-container"
      }, this.renderErrors(), /*#__PURE__*/React.createElement("h2", null, "Describe your project"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 mb-2"
      }, "Need help completing this section?\xA0", /*#__PURE__*/React.createElement("a", {
        onClick: this.handleTextSuggestions,
        tabIndex: 0,
        role: "button"
      }, "Add Text Suggestions")), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("textarea", {
        name: "projectScope",
        className: "scope-form form-control fs-hide null",
        required: "required",
        value: this.state.projectScope || null,
        onChange: this.setScope
      }), this.renderButtons()), /*#__PURE__*/React.createElement("div", {
        className: "g-column g-flex-3 protip-container"
      }, /*#__PURE__*/React.createElement(ProTip, null, "Add information about your company, the team, project scope, and candidate expectations."))));
    }
  }, {
    key: "renderModalLink",
    value: function renderModalLink() {
      return /*#__PURE__*/React.createElement("i", {
        role: "button",
        tabIndex: 0,
        className: "fa fa-edit modal-link",
        onClick: this.handleShowModal
      }, this.props.formType === 'modal-link' ? 'Edit' : '');
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.formType === 'page') {
        return this.renderContent();
      }
      return /*#__PURE__*/React.createElement("div", null, this.renderModalLink(), this.renderModal());
    }
  }]);
}(Component);
ProjectScope.propTypes = {
  formType: PropTypes.string,
  // one of 'page', 'modal-link', 'modal-icon'
  projectResourceId: PropTypes.string,
  csrfToken: PropTypes.string.isRequired,
  back: PropTypes.func,
  afterSubmit: PropTypes.func,
  getProjectDetails: PropTypes.func.isRequired,
  projectScope: PropTypes.string,
  backButtonText: PropTypes.string,
  submitButtonText: PropTypes.string
};
ProjectScope.defaultProps = {
  formType: 'page',
  projectResourceId: null,
  projectScope: '',
  back: function back() {},
  afterSubmit: function afterSubmit() {},
  backButtonText: 'Back',
  submitButtonText: 'Next'
};
export default ProjectScope;